import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import {
  FileTextOutlined,
  CheckSquareOutlined,
  FormOutlined,
} from '@ant-design/icons';
import LibraryPage from '../../../components/layout/LibraryPage';
import TemplateList from './TemplateList';
import PublishedList from './PublishedList';
import CompletedList from './CompletedList';

const { TabPane } = Tabs;

export default function Library() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab from URL
  const getActiveTab = () => {
    if (location.pathname.includes('/library/published')) return 'published';
    if (location.pathname.includes('/library/completed')) return 'completed';
    return 'templates';
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  const handleTabChange = (key) => {
    setActiveTab(key);
    navigate(`/library/${key}`);
  };

  return (
    <LibraryPage
      title="Library"
      breadcrumbs={[
        { label: 'Library', path: '/library' },
      ]}
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        size="large"
        style={{ padding: '0 24px' }}
      >
        <TabPane
          tab={
            <span>
              <FileTextOutlined />
              Templates
            </span>
          }
          key="templates"
        >
          <TemplateList embedded />
        </TabPane>

        <TabPane
          tab={
            <span>
              <CheckSquareOutlined />
              Published
            </span>
          }
          key="published"
        >
          <PublishedList embedded />
        </TabPane>

        <TabPane
          tab={
            <span>
              <FormOutlined />
              Completed
            </span>
          }
          key="completed"
        >
          <CompletedList embedded />
        </TabPane>
      </Tabs>
    </LibraryPage>
  );
}
